import React from 'react';

const Loader = () => (
  <div className='center-center'>
    LOADING...
  </div>
);

export default Loader;
